import angular from 'angular';

import ViewNewsfeedModalCtrl from '../ViewNewsfeedModalCtrl';
import modalNewsfeedViewUrl from '../modal-newsfeed-view.html';
import editArticleUrl from '../edit-article.html';

export default function Articles(
  Restangular,
  Comments,
  Authentication,
  NewsfeedCollection,
  RenderContent,
  AlertService,
  $sce,
  $uibModal,
  dateFilter,
  linkyFilter
) {
  'ngInject';

  Restangular.extendModel('articles', (article) => {
    article.posted = new Date(article.posted);
    article.date = dateFilter(article.posted, 'dd-MM-yyyy');
    article.commentsCanBeLiked = true;
    article.isLoadingComments = false;

    if (article.content) {
      article.renderedContent = RenderContent.get(article.content, true);
    }

    if (article.link) {
      article.renderedLink = linkyFilter(article.link, '_blank');
      article.renderedLink = $sce.trustAsHtml(article.renderedLink);
    }

    if (!article.seenby) {
      article.seenby = 0;
    }

    if (!article.commentlist) {
      article.commentlist = [];
    }

    Restangular.restangularizeCollection(article, article.commentlist, 'comments');

    if (article.user) {
      Restangular.restangularizeElement(null, article.user, 'users');
    }

    article.like = function likeArticle() {
      article.likes++;
      article.liked = true;
      article.likePending = true;

      return article
        .all('likes')
        .post()
        .catch((error) => {
          article.likes--;
          article.liked = false;
          console.log(error);
        })
        .finally(() => {
          article.likePending = false;
        });
    };

    article.unlike = function unlikeArticle() {
      article.likes--;
      article.liked = false;
      article.likePending = true;

      return article
        .all('likes')
        .remove()
        .catch((error) => {
          article.likes++;
          article.liked = true;
          console.log(error);
        })
        .finally(() => {
          article.likePending = false;
        });
    };

    article.toggleLike = function toggleLike() {
      // prevent sending multiple like/unlike requests in a row when user clicks fast
      if (article.likePending) {
        return;
      }

      if (article.liked) {
        return this.unlike(article);
      }

      return this.like(article);
    };

    article.togglePinArticle = function togglePinArticle(toggle) {
      article.sticky = toggle;
      article.put();
    };

    article.showArticleModal = function showArticleModal(type) {
      article
        .all(type)
        .getList({ 'user-fields': 'id' })
        .then((data) => {
          Restangular.restangularizeCollection(null, data, 'users');

          $uibModal
            .open({
              size: 'sm',
              templateUrl: modalNewsfeedViewUrl,
              controller: ViewNewsfeedModalCtrl,
              controllerAs: 'ctrl',
              resolve: {
                type() {
                  return type;
                },
                users() {
                  return data;
                },
              },
            })
            .result.ignoreCancel();
        });
    };

    article.getComments = () => {
      if (angular.isUndefined(article.gotComments)) {
        article.gotComments = true;
        article.isLoadingComments = true;
        return article
          .all('comments')
          .getList({ 'user-fields': 'id' })
          .then((data) => {
            article.commentlist = data;
            article.isLoadingComments = false;
          });
      }
    };

    article.canActOnArticle = function canActOnArticle() {
      const page = NewsfeedCollection.allChannels.find((c) => c.id === article.channel.id);
      if (!NewsfeedCollection.employeeCanActOnPage(page, Authentication.user)) {
        return false;
      }

      if (!NewsfeedCollection.canPostArticle(article.channel, Authentication.user)) {
        return false;
      }

      if (Authentication.user?.isManager) {
        return true;
      }

      if (article.user) {
        return article.user.isMe;
      }

      return false;
    };

    article.canEditArticle = function canEditArticle() {
      return article.user?.isMe && article.canActOnArticle();
    };

    article.editArticle = function editArticle() {
      const modalInstance = $uibModal.open({
        backdrop: 'static',
        templateUrl: editArticleUrl,
        size: '620',
        controllerAs: 'editCtrl',
        controller(articleCopy, Mentions, PersonaCollection, Upload, $window) {
          'ngInject';

          const editCtrl = this;

          const page = NewsfeedCollection.allChannels.find((c) => c.id === articleCopy.channel.id);

          editCtrl.article = articleCopy;
          editCtrl.mentions = new Mentions(page.id === 0 ? PersonaCollection.users : page.members);

          editCtrl.removeUpload = function removeUpload(index) {
            editCtrl.article.attachments.splice(index, 1);
          };

          if (editCtrl.article.attachments?.length) {
            editCtrl.article.attachments = editCtrl.article.attachments.filter(
              (attachment) => attachment.mimetype !== 'text/html'
            );

            editCtrl.article.attachments.forEach((attachment) => {
              const parts = attachment.url.split('/');
              attachment.fileName = decodeURIComponent(parts[parts.length - 1]);
            });
          }

          editCtrl.uploader = angular.copy(Upload.uploader);

          editCtrl.uploader.onSuccessItem = function uploaderOnSuccessItem(fileItem, response) {
            response.fileName = fileItem.file.name;

            if (!editCtrl.article.attachments) {
              editCtrl.article.attachments = [];
            }

            editCtrl.article.attachments.push(response);
          };

          editCtrl.uploader.onErrorItem = function uploaderOnErrorItem(item, response, status) {
            if (status === 413 || status === 0) {
              $window.alert('Your attachment is too big to upload to Sling.');
            } else {
              $window.alert(
                'Something went wrong while uploading the attachment. Please try again later.'
              );
            }
          };

          editCtrl.onContentChange = function onContentChange(text, attachments) {
            if (typeof text === 'string') {
              editCtrl.article.content = text;
            }

            if (attachments) {
              editCtrl.article.attachments = attachments;
            }
          };

          editCtrl.showErrorToast = (error) => {
            if (error) {
              AlertService.danger(error);
            }
          };
        },
        resolve: {
          articleCopy() {
            return angular.copy(article);
          },
        },
      });

      modalInstance.result.then(
        (articleCopy) => {
          angular.extend(article, articleCopy);
          article.put();
        },
        () => {
          console.log('Modal cancelled');
        }
      );
    };

    return article;
  });

  Restangular.addRequestInterceptor((element, operation, what) => {
    if (what === 'articles') {
      // Do NOT send a payload for the DELETE, see https://github.com/getsling/sling-server/issues/1369
      if (operation === 'remove') {
        return null;
      }
    }

    return element;
  });

  function _updateArticleLike(data, operation) {
    if (operation === 'post') {
      NewsfeedCollection.addArticleLike(data);
    }

    if (operation === 'remove') {
      NewsfeedCollection.deleteArticleLike(data);
    }
  }

  function _updateCommentLike(data, operation) {
    if (operation === 'post') {
      NewsfeedCollection.addCommentLike(data);
    }

    if (operation === 'remove') {
      NewsfeedCollection.deleteCommentLike(data);
    }
  }

  function _updateArticle(data, operation) {
    if (operation === 'post') {
      NewsfeedCollection.addArticle({ ...data, highlight: true });
    }

    if (operation === 'put') {
      NewsfeedCollection.editArticle(data);
    }

    if (operation === 'remove') {
      NewsfeedCollection.deleteArticle(data);
    }
  }

  Restangular.addResponseInterceptor((data, operation, what) => {
    if (what === 'likes' && data.articleId && !data.commentId) {
      _updateArticleLike(data, operation);
    }

    if (what === 'likes' && data.articleId && data.commentId) {
      _updateCommentLike(data, operation);
    }

    if (what === 'articles') {
      _updateArticle(data, operation);
    }

    return data;
  });

  return Restangular.service('articles');
}
